import { CASE_SET_ASK_AI_SEARCH_TYPE } from './constants';

export function setAskAiSearchType(searchType) {
  return {
    type: CASE_SET_ASK_AI_SEARCH_TYPE,
    data: searchType,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CASE_SET_ASK_AI_SEARCH_TYPE:
      return {
        ...state,
        askAiSearchType: action.data,
      };

    default:
      return state;
  }
}
